import { render, staticRenderFns } from "./DesenvolvedorEstagio.vue?vue&type=template&id=999d868c&"
import script from "./DesenvolvedorEstagio.vue?vue&type=script&lang=ts&"
export * from "./DesenvolvedorEstagio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports